import { apiFetch } from "../services/fetchApi";

export const fetchUsersCreate = async (BeURL, showAlert, formData, companyId, setUsers, setReportingMates) => {
    try {
        // 2️⃣ Send companyId as query param for account creation
        const accountRes = await apiFetch(`${BeURL}/create-account?id=${companyId}`, {
            method: "POST",

            body: formData, // FormData (images/files)
        });

        const accountData = await accountRes.json();
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }

        showAlert(accountData.message);
        setUsers({
            firstName: '',
            lastName: '',
            fullName: '',
            email: '',
            alternateEmail: '',
            contact: '',
            alternateContact: '',
            companyId: '',
            role: '',
            password: '',
            confirmPwd: ''
        })
        setReportingMates({
            reportingManagerId: '',
            reportingTeamLeadIds: ''
        })
        window.location.reload()


    } catch (err) {
        console.error("Error in Account create:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
};
